import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './dragfix.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { initAuth } from './redux/slices/authSlice';
import reportWebVitals from './reportWebVitals';
import logger from './utils/logger';
import storage from './utils/LocalStorageManager';
import { getDefaultWallpaper, wallpapers, applyWallpaper, findWallpaperByValue } from './config/wallpapers';

// 在应用启动时初始化身份验证状态
store.dispatch(initAuth());

// 在DOM渲染前先加载壁纸背景（高优先级）
(function initWallpaper() {
  try {
    // 从storage获取壁纸设置
    const savedWallpaper = storage.getWallpaper();
    let wallpaperObject = null;
    
    // 优先尝试获取保存的完整壁纸对象
    const savedWallpaperObject = storage.getItem('wallpaper_object', true);
    if (savedWallpaperObject) {
      wallpaperObject = savedWallpaperObject;
    } else if (savedWallpaper) {
      // 如果没有完整的壁纸对象，根据保存的壁纸值找到对应的壁纸对象
      wallpaperObject = findWallpaperByValue(savedWallpaper);
    }
    
    if (wallpaperObject) {
      // 使用封装的applyWallpaper方法
      applyWallpaper(wallpaperObject);
    } else if (savedWallpaper) {
      // 如果找不到对应的壁纸对象，只应用背景
      document.body.style.background = savedWallpaper;
      document.body.style.backgroundAttachment = 'fixed';
      document.body.style.backgroundSize = 'cover';
    } else {
      // 如果没有保存的壁纸设置，应用默认壁纸
      wallpaperObject = getDefaultWallpaper();
      applyWallpaper(wallpaperObject);
    }
  } catch (error) {
    logger.error('预加载壁纸失败:', error);
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <Provider store={store}>
      <App />
    </Provider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
